import React from 'react';
import moment from 'moment';

const IncrementalUpdateTime = ({ datetime, from }) => {
  if (from === 'now') {
    return <span title={`Time since now`}>{moment(datetime).fromNow()}</span>;
  } else {
    return (
      <span title={'Time since previous update'}>
        {' '}
        ({moment(datetime).from(from, true)})
      </span>
    );
  }
};

export default IncrementalUpdateTime;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncrementalUpdateTime.js